import { Pipe, PipeTransform } from '@angular/core';
import { MainFilterItem } from '../models/mainFilterItem';
import { GridHeader } from '../models/gridHeader';

@Pipe({
  name: 'showIf'
})
export class ShowIfPipe implements PipeTransform {
  transform(header: GridHeader, mainFilterItems: MainFilterItem[]): boolean {
    if (!header?.showIfReq) return true;

    if (header?.showIfReq?.isFilter) {
      if (header?.showIfReq?.isFilter?.platform) {
        let osMainFilter = mainFilterItems.find(
          filter => filter.key === 'platformName'
        );
        if (osMainFilter) {
          if (
            osMainFilter.selected.value !==
            header?.showIfReq?.isFilter?.platform
          )
            return false;
        }
      }
    }

    return true;
  }
}
